import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { v4 as uuidv4 } from 'uuid'

export interface CashAuthState {
  loginIntentToken?: string
  challengeToken?: string
  attestations: string[]
  accessToken?: string
  journeyId: string
  maskedDeliveryTarget?: string
}

export const cashAuthInitialState: CashAuthState = {
  loginIntentToken: undefined,
  challengeToken: undefined,
  attestations: [],
  accessToken: undefined,
  journeyId: uuidv4(),
  maskedDeliveryTarget: undefined,
}

const cashAuthSlice = createSlice({
  name: 'cashAuth',
  initialState: cashAuthInitialState,
  reducers: {
    setLoginIntent(state, action: PayloadAction<{ loginIntentToken: string }>) {
      state.loginIntentToken = action.payload.loginIntentToken
      state.challengeToken = undefined
      state.attestations = []
      state.accessToken = undefined
      state.maskedDeliveryTarget = undefined
    },
    setChallenge(state, action: PayloadAction<{ challengeToken: string; maskedDeliveryTarget?: string }>) {
      state.challengeToken = action.payload.challengeToken
      state.maskedDeliveryTarget = action.payload.maskedDeliveryTarget
    },
    addAttestation(state, action: PayloadAction<string>) {
      if (!state.attestations.includes(action.payload)) {
        state.attestations.push(action.payload)
      }
    },
    setRedeemSuccess(state, action: PayloadAction<{ accessToken: string; attestations: string[] }>) {
      state.accessToken = action.payload.accessToken
      state.attestations = action.payload.attestations
    },
    resetCashAuth(state) {
      state.loginIntentToken = undefined
      state.challengeToken = undefined
      state.attestations = []
      state.accessToken = undefined
      state.maskedDeliveryTarget = undefined
      state.journeyId = uuidv4()
    },
  },
})

export const { setLoginIntent, setChallenge, addAttestation, setRedeemSuccess, resetCashAuth } = cashAuthSlice.actions

export default cashAuthSlice.reducer
